import { render, staticRenderFns } from "./LayoutLogin.vue?vue&type=template&id=afca3c3c&scoped=true&"
import script from "./LayoutLogin.vue?vue&type=script&lang=ts&"
export * from "./LayoutLogin.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutLogin.vue?vue&type=style&index=0&id=afca3c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afca3c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VCard,VIcon,VMain})
